import React from 'react'
import Translation from '../../global/Translation'
import LocalizedLink from '../../global/LocalizedLink'
import Banos_V2 from '../../../assets/img/banners-v2/NewBanos_v2.png'
import BannerShortCatalogNaturalStone from '../../banners/banner-natural-stone/BannerShortCatalogNaturalStone'

export default class BannerResultV2 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { currentLocation, naturalStoneViewingPermissions } = this.props

        const slabLocation = (currentLocation && currentLocation.section) ? ['slab'].includes(currentLocation.section) : false

        const banner = [
            Banos_V2,
            <Translation id="standard_products" defaultMessage="Standard Products" />,
            <Translation id="banner_bath_subtitle" defaultMessage="Washbasins, shower trays and optima boards" />,
            <Translation id="view_section" defaultMessage="View secction" />,
            'cover',
            'center center',
            null,
            '?type[0]=BASIN&type[1]=VANITY&type[2]=SINK&type[3]=STRAY&type[4]=TILE&type[5]=CLAD&type[6]=FLOOR&type[7]=CLAD_FLOOR',
            { outlet: '' },
            'ROUTE_CATALOG'
        ]

        return !slabLocation && (naturalStoneViewingPermissions.canViewHQ || naturalStoneViewingPermissions.canViewBrazil) ? (
            <BannerShortCatalogNaturalStone />
        ) : (
            <LocalizedLink routeId={banner[9]} queryString={banner[7]} params={banner[8]} gtmLabel="ec_banner_list">
                <div
                    className={'box-parent-banner-result-v2'}
                    style={{
                        backgroundImage: `url(${banner[0]})`,
                        backgroundSize: banner[4],
                        backgroundPosition: banner[5]
                    }}
                >
                    <div className="box-container" style={banner[6] ? { background: `linear-gradient(179.95deg, #494E51 ${banner[6]}, rgba(58, 58, 58, 0) 99.94%)` } : {}}>
                        <div className={`box-title  ${banner[0] === Banos_V2 ? 'maxi' : ''}`}>{banner[1]}</div>
                        <div className="box-subtitle">{banner[2]}</div>
                        <div
                            className="box-button-container"
                            style={{
                                maxHeight: '230px'
                            }}
                        >
                            <div className="v2 bt bt-inverted bt-size-large">{banner[3]}</div>
                        </div>
                    </div>
                </div>
            </LocalizedLink>
        )
    }
}
